import { Content, Footer, Header, RouterContext } from '../../gs-component-right-rail';
import { Button } from '@xo-union/tk-component-buttons';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { FormikProps } from 'formik';
import React, { useContext } from 'react';

import { CustomVendorFields } from '../components/Form/CustomVendorFields';
import { LocationContext } from '../components/LocationContext';
import RightRailSection from '../components/RightRailSection';
import hasAddress from '../helpers/addressHelpers';
import { SoEInitialValues } from './ScheduleOfEventsForm';
import { getVendorProfileId } from '../helpers/getBookingBody';
interface Props {
  params?: {
    namePrefix: string;
    eventType: string;
    index: number;
    remove?: (index: number) => void;
    newItem?: boolean;
  };
  formProps: FormikProps<SoEInitialValues>;
}

export const CustomVendorPage: React.FC<Props> = ({ params, formProps }) => {
  const { push, previousView } = useContext(RouterContext);
  const { setCeremonyAddress, setReceptionAddress, location } = useContext(LocationContext);
  const { namePrefix = '', index, eventType, ...rest } = params || {};

  const goBack = (): void => {
    push({
      screen: previousView,
      params: {
        index,
        ...rest,
      },
    });
  };

  const resetAndGoBack = (): void => {
    const { initialValues, setFieldValue } = formProps;
    const { location: { name = '', zip = '', city = '', state = '', country = '', street1 = '' } = {} } = initialValues;

    setFieldValue(`${namePrefix}location.zip`, zip);
    setFieldValue(`${namePrefix}location.city`, city);
    setFieldValue(`${namePrefix}location.state`, state);
    setFieldValue(`${namePrefix}location.country`, country);
    setFieldValue(`${namePrefix}location.street1`, street1);
    setFieldValue(`${namePrefix}location.name`, name);
    goBack();
  };

  const addCustomVendor = (): void => {
    if (
      !formProps.values.subEvents ||
      !formProps.values.subEvents[index as number] ||
      !hasAddress(formProps.values.subEvents[index as number].location)
    ) {
      return goBack();
    }

    const { city, country, name, state, street1, zip } = formProps.values.subEvents[index as number].location || {};

    if (eventType === 'Ceremony') {
      setCeremonyAddress({
        id: location.CER && location.CER.id,
        // set initial vendor_profile_id as empty string
        ...getVendorProfileId(location.CER ? location.CER.vendor_profile_id : ''),
        vendor_name: name,
        address_components: {
          user_entry: {
            street: street1,
            city,
            postal_code: zip,
            state,
            country,
          },
        },
      });
    } else if (eventType === 'Reception') {
      setReceptionAddress({
        id: location.REC && location.REC.id,
        // set initial vendor_profile_id as empty string
        ...getVendorProfileId(location.REC ? location.REC.vendor_profile_id : ''),
        vendor_name: name,
        address_components: {
          user_entry: {
            street: street1,
            city,
            postal_code: zip,
            state,
            country,
          },
        },
      });
    }
    goBack();
  };

  return (
    <>
      <Header leftButtonText="Back" leftButtonOnClick={resetAndGoBack}>
        Add Custom Vendor
      </Header>
      <Content>
        <RightRailSection name="Vendor Information">
          <FormBlockColumn>
            <CustomVendorFields namePrefix={namePrefix} />
          </FormBlockColumn>
        </RightRailSection>
      </Content>
      <Footer>
        <Button block type="button" onClick={addCustomVendor}>
          Done
        </Button>
      </Footer>
    </>
  );
};
